export default __webpack_public_path__ + "static/media/dieternuhr1001.c542165e.jpg";